import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { LoadableDataState } from "@my-dld/utils/UIUtils";
import { EjariContractContext, updateContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import React, { Component } from "react";
import FormSection from "@my-dld/components/Form/FormSection";
import Strings from "@my-dld/assets/strings";
import FormRow from "@eres/forms-web/FormRow";
import FormAction from "@my-dld/components/Form/FormAction";
import { ContractTerm } from "@eres/ejari-api/Entity/contract";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import YesNoField from "../../../../eres/forms-web/YesNoField";
import FormSubSection, { SectionAction } from "@eres/forms-web/FormSubSection";
import TextInputField from "@eres/forms-web/TextInputField";
import { valueRenderer } from "./ContractCalculatedValue";
import ContractItems, { EditAction, ItemViewProps, NewItemProps, NewItemState, RemoveAction } from "./ContractItems";
import { checkNonEmpty } from "../../utils";
import { ErrorContainer } from "@eres/forms";
import _ from "lodash";
import Popup from "@my-dld/components/Popup/Popup";
import TextAreaInputField from "@eres/forms-web/TextAreaInputField";
import noEnglishConverter from "@eres/forms/converters/NoEnglishConverter";
import noArabicConverter from "@eres/forms/converters/NoArabicConverter";
import { TenancyContactAction } from "@eres/ejari-core/constants";
import { EjariPropertyUsage } from "@eres/ejari-api/Entity";

interface Props extends RoutedViewProps {
}


interface State extends LoadableDataState {
	isValid: boolean;
	AdditionalTerms?: ContractTerm[];
	tenantApproval: boolean;
}


class TermsAndConditions extends Component<Props, State> {
	static contextType = EjariContractContext;
	context!: React.ContextType<typeof EjariContractContext>;
	itemsView = React.createRef<ContractItems<ContractTerm>>();

	constructor( props: Props ) {
		super( props );
		this.state = {
			loadState: "done",
			isValid: true,
			errorContainer: {},
			tenantApproval: false,
		};
	}

	componentDidMount() {
		let ctx = this.context;
		const update: Partial<State> = {};
		if ( ctx.AdditionalTerms != null ) update.AdditionalTerms = ctx.AdditionalTerms;
		if ( ctx.tenantApproval != null ) update.tenantApproval = ctx.tenantApproval;

		this.setState( update as State );
	}

	buildItemForAddNew = () => {
		return { EnglishTerm: undefined, ArabicTerm: undefined };
	};
	onAddNewTerm = () => {
		this.itemsView.current?.onAddNewItem();
	};
	onItemsChanged = ( items: ContractTerm[] ) => {
		this.setState( {
			AdditionalTerms: items
		} );
	};
	renderItem = ( props: ItemViewProps<ContractTerm>, state: ContractTerm, fieldProps: Partial<WebFormFieldProps<any, any>> ) => {
		const { position } = props;
		const title = position + ". ";
		const onAction = ( actionId: string, action: SectionAction ) => {
			this.onItemAction( actionId, { ...action, data: props.data } );
		};
		const actions: SectionAction[] = [ EditAction, RemoveAction ];// this.EditAction, this.RemoveAction ];
		return <FormSubSection
			onAction={ onAction }
			title={ title }
			actions={ actions }>
			<FormRow { ...fieldProps }>
				<TextInputField
					mode={ "text" }
					textRenderer={ valueRenderer as any }
					label={ Strings.english }
					id={ "EnglishTerm" }
				/>
				<TextInputField
					mode={ "text" }
					textRenderer={ valueRenderer as any }
					label={ Strings.arabic }
					id={ "ArabicTerm" }
				/>
			</FormRow>
		</FormSubSection>;
	};
	onItemAction = ( actionId: string, action: SectionAction ) => {
		const data = action.data as ContractTerm;
		switch ( actionId ) {
			case "edit":
				this.itemsView.current?.onEditItem( data );
				break;
			case "delete":
				const np = this.state.AdditionalTerms?.filter( x => x != data );
				this.setState( { AdditionalTerms: np } );
				break;
		}
	};
	validateItem = ( prevResult: boolean, data: ContractTerm, errorContainer: ErrorContainer, props: NewItemProps<ContractTerm>, state: NewItemState<ContractTerm> ) => {
		prevResult = prevResult && checkNonEmpty( data, "ArabicTerm", errorContainer );
		prevResult = prevResult && checkNonEmpty( data, "EnglishTerm", errorContainer );
		return prevResult;
	};
	extractUpdatedData = ( props: NewItemProps<ContractTerm>, state: NewItemState<ContractTerm> ) => {
		const data: ContractTerm = _.omit( state, "isValid", "errorContainer", );
		return data;
	};
	renderForm = ( props: NewItemProps<ContractTerm>, state: NewItemState<ContractTerm>, fieldProps: Partial<WebFormFieldProps<any, any>>, onDone: () => void ) => {
		const { isEdit } = props;
		const { isValid } = state;
		delete fieldProps.containerClassName;
		fieldProps.containerClassName = "col-md-12 form-group";
		return <Popup
			title={ Strings.add_terms_conditions }
			showIcon={ false }
			clickOutsideToDismiss={ false }
			id={ props.dialogId } modalBodyContainer="" modalSubContainer="modal-dialog modal-dialog-centered modal-ejari-contract-payment modal-lg">
			<div className={ "modal-body" }>
				<FormRow { ...fieldProps }>
					<TextAreaInputField
						required={ true }
						id={ "EnglishTerm" }
						containerClassName={ "form-group flex-fill" }
						label={ Strings.english }
						valueConverter={ noArabicConverter }
					/>
				</FormRow>
				<FormRow { ...fieldProps }>
					<TextAreaInputField
						required={ true }
						id={ "ArabicTerm" }
						containerClassName={ "form-group flex-fill" }
						label={ Strings.arabic }
						valueConverter={ noEnglishConverter }
					/>
				</FormRow>

			</div>
			<FormAction
				disablePrimaryAction={ !isValid }
				groupClassName={ "text-center" }
				primaryActionLabel={ isEdit ? Strings.update : Strings.add }
				onPrimaryAction={ onDone }
			/>
		</Popup>;
	};

	render() {
		const { isValid } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-6 form-group",
			errorManager: defaultErrorManager,
		};
		return (
			<>
				<FormSection
					title={ Strings.terms_and_conditions }
					action={ <button
						className="btn btn-sm"
						onClick={ this.onAddNewTerm } type="button">
						<i className="fa fa-plus"/> { Strings.add_terms_conditions }
					</button> }
				>
					<ContractItems
						dialogId={ "NewTerms" }
						ref={ this.itemsView }
						items={ this.state.AdditionalTerms }
						onItemsChanged={ this.onItemsChanged }
						renderItem={ this.renderItem }
						buildItemForAddNew={ this.buildItemForAddNew }
						validateItem={ this.validateItem }
						extractUpdatedData={ this.extractUpdatedData }
						renderForm={ this.renderForm }
					/>
					<FormRow { ...filedProps }>
						<YesNoField
							yesLabel={ Strings.yes }
							noLabel={ Strings.no }
							id={ "tenantApproval" }
							containerClassName={ "notification-to-tenant col-md-12" }
							label={ Strings.tenant_approval }/>
					</FormRow>

				</FormSection>
				<FormRow>
					<FormAction
						disablePrimaryAction={ !isValid }
						groupClassName={ "text-center" }
						primaryActionLabel={ Strings.submit }
						onPrimaryAction={ this.onContinue }
						secondaryActionLabel={ Strings.back }
						onSecondaryAction={ this.onBack }
					/>
				</FormRow>
			</>
		);
	}


	onContinue = () => {
		const d = this.state;
		updateContractContext( {
			tenantApproval: d.tenantApproval,
			AdditionalTerms: d.AdditionalTerms,
		} );
		requestAnimationFrame( () => {
			this.context.submitContract( this.context ).then( x => {
				let backStack = 4;
				const { action, property } = this.context;
				const isIndustrial = property?.EjariPropertyUsageId === EjariPropertyUsage.INDUSTRIAL;
				if ( action === TenancyContactAction.NEW_CONTRACT ) {
					backStack = 6;
					if ( isIndustrial ) {
						backStack = 6;
					}
				} else if ( action === TenancyContactAction.RENEW_CONTRACT && isIndustrial ) {
					backStack = 5;
				}
				const nx = _.pick( this.context, "activeUserId", "userType", "action", );
				updateContractContext( {
					...nx,
					newContract: x,
					actionDone: true,
				} );
				this.props.history.go( -backStack );

//            replaceNavigate("success")
				// no need to handle here unless default behaviour of context is not enough
			} ).catch( e => {
				// no need to handle here unless default behaviour of context is not enough
			} );
		} );

	};
	onBack = () => {
		this.props.history.goBack();
	};
}

export default TermsAndConditions;
